import {Fragment} from 'react';
// import {GoLightBulb as Bulb} from 'react-icons/go';
// import {
//   RiPieChart2Line as PieChart,
//   RiUserLocationLine as HR,
//   RiMacLine as Machine,
// } from 'react-icons/ri';
// import {TiShoppingCart as Cart} from 'react-icons/ti';
// import {BsChatRightText as Chat} from 'react-icons/bs';
// import {TfiHeadphoneAlt as BPO} from 'react-icons/tfi';
// import {GoLaw as Legal} from 'react-icons/go';

import {Image} from '@jobseeker/lotus/components/Image';
import {Section, Box} from '@jobseeker/lotus/foundations';
import Link from '@jobseeker/lotus/elements/Link';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {ArrowForwardIos} from '@mui/icons-material';

import {ROUTE_CATEGORY, ROUTE_TAG} from '@constants';

import {
  BankingFinanceJobs,
  AIJobs,
  SalesMarketingJobs,
  ConsultingJobs,
  HRIRJobs,
  ITSystemJobs,
  SCMOperationJobs,
  LegalJobs,
  BPOJobs,
} from '@jobseeker/lotus/assets/icons';
// import Icons from './Icons';

import type {
  FindOpportunityType,
  JobOpportunityNavType,
  LinkType,
} from '../types';
import {Typography} from '@mui/material';
import {handleTracking, openUrl, deferTask} from '@jobseeker/common-core/utils';

const FindOpportunity = (props: FindOpportunityType) => {
  const {eventTag, heading, theme} = props || {};

  const interceptor: /* eslint-disable @typescript-eslint/no-explicit-any */ any =
    useInterceptor();

  const {
    header: {
      meta: {tabsList},
    },
  } = interceptor;

  // const iconsArray = [PieChart, Cart, Chat, HR, Machine, Bulb, Legal, BPO];

  const iconsArray = [
    [BankingFinanceJobs, 'Banking and Finance Jobs'],
    [SalesMarketingJobs, 'Sales and Marketing Jobs'],
    [ConsultingJobs, 'Consulting Jobs'],
    [HRIRJobs, 'HR IR Jobs'],
    [ITSystemJobs, 'IT System Jobs'],
    [SCMOperationJobs, 'SCM Operations Jobs'],
    [LegalJobs, 'Legal Jobs'],
    [BPOJobs, 'BPO Jobs'],
    [AIJobs, 'GenAI Jobs'],
  ];

  const getCatTagPageLink = (routePath: string, tag = '') => {
    return `${routePath}/${tag
      .replace('&', '')
      .replace(/\s+/g, '-')
      .toLowerCase()}-jobs`;
  };

  // const Icon = ({index}: {index: number}) => (
  //   <Icons index={index} iconsArray={iconsArray} />
  // );

  const transTabsList = tabsList || [];

  return transTabsList && transTabsList.length ? (
    <Section>
      <Typography
        component={'h1'}
        sx={{
          textAlign: 'center',
          fontSize: {
            xxs: theme.typography.pxToRem(20),
            md: theme.typography.pxToRem(26),
          },
          fontWeight: {xxs: 600, md: 400},
          paddingLeft: theme.spacing(3),
          paddingRight: theme.spacing(3),
        }}
      >
        {heading}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xxs: '1fr',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
          },
          gap: {xxs: '16px', sm: '24px', md: '30px 40px'},
          maxWidth: '1010px',
          margin: '0 auto',
          paddingLeft: {xxs: theme.spacing(2.5), md: 0},
          paddingRight: {xxs: theme.spacing(2.5), md: 0},
        }}
        marginTop={{xxs: '45px', md: '26px'}}
      >
        {transTabsList.map((tab: JobOpportunityNavType, indexVal: number) => (
          <Fragment key={`home-findopportunity-${indexVal}`}>
            <Box
              sx={{
                display: 'flex',
                height: {xxs: 'auto', md: '210px'},
                backgroundColor: '#FFFFFF',
                border: '1px solid #E4E4E4',
                borderRadius: '8px',
                boxShadow: '0px 5px 8px 0px #0000000D',
                opacity: 1,
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: {xxs: 'column', sm: 'row'},
                  width: '100%',
                  alignItems: {xxs: 'center', sm: 'flex-start'},
                  textAlign: {xxs: 'center', sm: 'left'},
                  margin: {
                    xxs: `${theme.spacing(3.75)} ${theme.spacing(3.75)}`,
                    sm: `${theme.spacing(3.75)} ${theme.spacing(3.125)}`,
                    md: '16px 15px',
                  },
                  gap: {xxs: theme.spacing(2), md: '13px'},
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    backgroundColor: 'rgba(155, 254, 232, 0.15)',
                    position: 'relative',
                  }}
                >
                  <Image
                    src={tab['icon'] || iconsArray[indexVal]?.[0] || ''}
                    alt={iconsArray[indexVal]?.[1] || tab['label'] || ''}
                    width={32}
                    height={32}
                    style={{zIndex: 1}}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: {xxs: 'center', xs: 'left'},
                  }}
                >
                  <Link
                    href={getCatTagPageLink(ROUTE_CATEGORY, tab['tag'])}
                    target="_blank"
                    key={`home-findopportunity-${indexVal}`}
                    sx={{
                      fontWeight: 500,
                      fontSize: {
                        xxs: theme.typography.pxToRem(18),
                        md: theme.typography.pxToRem(14),
                      },
                      padding: 0,
                      opacity: 1,
                      cursor: 'pointer',
                      marginBottom: theme.spacing(0.25),
                      wordBreak: 'normal',
                      whiteSpace: 'normal',
                      width: {md: 'fit-content'},
                    }}
                    onClick={(e: React.MouseEvent) => {
                      e.preventDefault();
                      const url = getCatTagPageLink(ROUTE_CATEGORY, tab['tag']);
                      if (url) {
                        openUrl(url, '_blank');
                      }
                      deferTask(() => {
                        handleTracking(eventTag, {
                          event_category: 'engagement',
                          Label: tab['heading'],
                          Value: `${indexVal}`,
                        });
                      });
                    }}
                  >
                    {tab['heading'] + ' Jobs'}
                  </Link>
                  <Box
                    sx={{
                      display: 'flex',
                      height: '100%',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      {tab.menu
                        .slice(0, 4)
                        .map((link: LinkType, index: number) => {
                          return (
                            <Link
                              key={`home-findopportunity-menu${index}`}
                              target="_blank"
                              href={getCatTagPageLink(ROUTE_TAG, link['tag'])}
                              sx={{
                                p: 0,
                                fontSize: {
                                  xxs: theme.typography.pxToRem(16),
                                  sm: theme.typography.pxToRem(12),
                                },
                                color: {md: '#333333'},
                                fontWeight: 400,
                                lineHeight: {md: '26px'},
                                opacity: 1,
                                wordBreak: 'normal',
                                whiteSpace: 'normal',
                                display: 'block',
                                width: {md: 'fit-content'},
                              }}
                              onClick={(e: React.MouseEvent) => {
                                e.preventDefault();
                                const url = getCatTagPageLink(
                                  ROUTE_TAG,
                                  link['tag']
                                );
                                if (url) {
                                  openUrl(url, '_blank');
                                }
                                deferTask(() => {
                                  //navToJobCategoryAndTagPage(ROUTE_TAG);
                                  handleTracking(eventTag, {
                                    event_category: 'companies',
                                    Label: link['label'] || '',
                                    Value: `${index}`,
                                  });
                                });
                              }}
                            >
                              {link['label']}
                            </Link>
                          );
                        })}
                    </Box>

                    <Box>
                      {tab.menu.length > 0 && (
                        <Link
                          href={getCatTagPageLink(ROUTE_CATEGORY, tab['tag'])}
                          target="_blank"
                          sx={{
                            textDecoration: 'none',
                            padding: 0,
                            opacity: 1,
                            width: {md: 'fit-content'},
                            '&:hover': {
                              textDecoration: 'none',
                            },
                          }}
                        >
                          <Box
                            sx={{
                              height: '26px',
                              fontWeight: 500,
                              fontStyle: 'normal',
                              fontSize: {xxs: '15px', sm: '10px', md: '12px'},
                              lineHeight: '26px',
                              cursor: 'pointer',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: {xxs: 'center', sm: 'left'},
                              gap: '4px',
                              bottom: {xxs: '0px', lg: '0px', xl: '17px'},
                            }}
                          >
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#159076',
                              }}
                            >
                              View all
                            </span>
                            <ArrowForwardIos
                              sx={{
                                fontSize: '12px',
                                color: 'black',
                                display: 'flex',
                                alignItems: 'center',
                              }}
                            />
                          </Box>
                        </Link>
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Fragment>
        ))}
      </Box>
    </Section>
  ) : (
    <></>
  );
};
export default FindOpportunity;
